import { Grid, Card, Box, Typography, styled, Menu } from '@mui/material';
import React, { useState } from 'react';
import { AppAvatar } from 'components/Avatar';
import styles from '../GridMode.module.scss';
import { Button } from 'tt-ui-lib/core';
import { MessageIcon, OrdersIcon } from 'tt-ui-lib/icons';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const GridItem = ({ user }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const StyledMenu = styled((props) => (
    <Menu
      id="user-info-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'menu-button',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
      '& .MuiMenu-list': {},
    },
  }));

  return (
    <Grid item xs={6} sm={4} md={3} xl={3}>
      <Card className={styles.card}>
        <Box className={styles.cardImageBlock}>
          <Box>
            <AppAvatar
              userName={`${user.first_name} ${user.last_name}`}
              src={user.avatar}
              nav={0}
              role={user.roles[0]?.name}
              size="lg"
            />
          </Box>
        </Box>
        <Box className={styles.userInfo}>
          <Typography className={styles.userName}>
            {`${user.first_name} ${user.last_name}`}
          </Typography>
          <Box className={styles.experiences}>
            <OrdersIcon style={{ marginRight: 5, width: 14, height: 14 }} />
            <Typography className={styles.experienceName}>
              {user.experiences[0]?.title} of{' '}
              <Typography className={styles.greenText}>
                {user.experiences[0]?.company_name}
              </Typography>
            </Typography>
          </Box>
          <Box className={styles.roleName}>{user.roles[0]?.name}</Box>
          <Box className={styles.connectionActions}>
            <Button type="icon">
              <img
                src="/images/templates/heart-icon.svg"
                alt=""
                style={{ width: 24, height: 24 }}
              />
            </Button>
            <Button type="icon">
              <MessageIcon className={styles.itemIcon} />
            </Button>
            <Button type="icon">
              <MoreVertIcon width={4} height={14} sx={{ color: '#18397A' }} />
            </Button>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

export default GridItem;
